






































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { State, Mutation } from 'vuex-class'
import { queryStatus } from '@/service/step-six'

@Component
export default class AuditTimeline extends Vue {
  @State applyStatus!: any
  @State bidType!: any
  @State coopChannel!: any
  @Mutation setStep!: Function
  @Mutation setApplyStatus!: Function
  @Prop() data?: object
  auditInfo: any = {}
  color = {
    success: '#67C23A',
    error: '#f5222d',
  }
  showDownload: boolean = false
  isEnterQr: boolean = false
  isEnterButton: boolean = false
  qrStyle = {
    left: '0px',
    top: '0px'
  }

  get show() {
    return this.coopChannel !== 2
  }
  get status() {
    return this.applyStatus === -1 ? 'error' : 'success'
  }

  get auditTip() {
    switch (this.applyStatus) {
      case -1:
        return '审核被驳回'
      case 8:
        return '恭喜！您现在已经可以登录商家后台了'
      default:
        return '我们将在3~5个工作日内完成审核'
    }
  }

  get auditResult() {
    switch (this.applyStatus) {
      case -1:
        return '审核失败'
      case 8:
        return '审核成功'
      default:
        return '完成各项资质的审核'
    }
  }

  get checkTime() {
    if (this.applyStatus === 0) {
      return `预计${this.auditInfo.estimate_check_time}可收到审核结果`
    }
    return this.auditInfo.check_time
  }

  async created() {
    this.auditInfo = this.data || (await queryStatus())
  }

  resubmit() {
    this.setStep(2)
    this.setApplyStatus(-2)
  }

  mounted() {
    const buttonDom = document.querySelector('.download') as any
    const left = buttonDom.offsetLeft + buttonDom.offsetWidth / 2
    const top = buttonDom.offsetHeight + buttonDom.offsetTop + 12
    this.qrStyle = {
      left: left + 'px',
      top: top + 'px'
    }
  }

  handleEnter() {
    this.isEnterQr = false
    this.isEnterButton = true
    this.showDownload = true
  }
  handleLeave() {
    this.isEnterButton = false
    setTimeout(() => {
      if (!this.isEnterQr) {
        this.showDownload = false
      }
    }, 100)
  }
  handleEnterQr() {
    this.isEnterQr = true
    this.isEnterButton = false
  }
  handleLeaveQr() {
    this.isEnterQr = false
    setTimeout(() => {
      if (!this.isEnterButton && !this.isEnterQr) {
        this.showDownload = false
      }
    }, 100)
  }
}
